var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-component"},[_c('div',{staticClass:"table-wrapper"},[_c('div',{staticClass:"scrollable-wrapper"},[_c('table',{ref:"table",on:{"&scroll":function($event){return _vm.scrollHandling('table', 'slider')}}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }